<template>
    <div>
      InvoiceDetail
    </div>
</template>

<script>
    export default {
        name: "InvoiceDetail"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/ServiceAdmin/InvoiceDetail.vue